import { UsuarioReferenciaService } from "./../../../../services/data-services/usuario.referencia.service";
import { Referencia } from "src/app/models/Referencia";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Comentario } from "../../../../models/Comentario";
import { TagConteudo } from "../../../../interfaces/TagConteudo";
import { HoverService } from "../../../../services/hover.service";
import { UsuarioComentariosService } from "../../../../services/data-services/usuario.comentarios.service";
import { TextoPagina } from "../../../../models/pagina/TextoPagina";

// azure card 358 Desativar botão caiu em prova
import { ProvaDatasource, ParametrosCaneta } from "../../../../models/UserData";
import { UsuarioMarcacoesService } from "../../../../services/data-services/usuario.marcacoes.service";
import { MatDialog } from "@angular/material/dialog";
import { SimNaoDialogComponent } from "../../../dialogs/sim-nao-dialog/sim-nao-dialog.component";
import { Observable, of, Subscription } from "rxjs";
import { UsuarioPreferenciasService } from "../../../../services/data-services/usuario.preferencias.service";
import { FeatureFlagService } from "src/app/services/feature-flag-service.service";
import { ReferenciaGerenciada } from "src/app/models/ReferenciaGerenciada";
import { ConfiguracoesUsuario } from "src/app/models/usuario/ConfiguracoesUsuario";
import { FuncoesProva } from "src/app/models/FuncoesProva";
import { Marcacao } from "src/app/models/Marcacao";
import { MarcacoesGroup } from "src/app/models/MarcacoesGroup";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";

@Component({
  selector: "app-marcacao-superior",
  templateUrl: "./marcacao-superior.component.html",
  styleUrls: ["./marcacao-superior.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarcacaoSuperiorComponent implements OnInit, OnDestroy {
  @Input() opcoesPonteiros: ParametrosCaneta;

  @Input() posicaoAtual: string;

  @Input() criarReferencia: Referencia;

  @Output() onSalvarReferencia = new EventEmitter<Referencia>();

  @ViewChild("controlProvaExistente") controlProvaExistente: ElementRef;

  configuracoes$: Observable<ConfiguracoesUsuario> = of(
    new ConfiguracoesUsuario()
  );
  public linha: TextoPagina;
  public provaEditando: Marcacao;
  public provaNova = false;
  public provaTextoBuscando: string;
  public carregandoOpcoesProva = true;
  public opcoesProva: ProvaDatasource;
  public funcoesProva = FuncoesProva;

  public provasExistentes = new Array<MarcacoesGroup>();
  public referenciagerenciadasReadOnly;

  public marginTop: number;
  public marginBottom: number;

  public isAdm = false;

  public anyMarcacoes: any;

  public comentarios: Comentario[];

  public mnemonicos: Comentario[];

  public comentariosGerenciados: Comentario[];

  public mnemonicosGerenciados: Comentario[];

  public comentariosLinhaAtual: Comentario[];

  public comentariosGerenciadosLinhaAtual: Comentario[];

  public marcacoesLinhaAtual: Marcacao[];

  public referenciaLinhaAtual: Referencia[];

  public referenciagerenciadasLinhaAtual: ReferenciaGerenciada[];

  private _provasExistentes = new Array<MarcacoesGroup>();
  private _bufferInputWidht: HTMLSpanElement;
  private subscriptions: Subscription[] = [];

  constructor(
    private changeDetector: ChangeDetectorRef,
    private hoverService: HoverService,
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private usuarioComentariosService: UsuarioComentariosService,
    private usuarioReferenciaService: UsuarioReferenciaService,
    private usuarioMarcacaoService: UsuarioMarcacoesService,
    private usuarioMarcacoesService: UsuarioMarcacoesService,
    private errorHandlerService: ErrorHandlerService,
    public dialog: MatDialog,
    public featureFlagService: FeatureFlagService
  ) {}

  @Input()
  set setLinha(novoValor: TextoPagina) {
    this.linha = novoValor;
    this.setLInhaconteudo();
  }

  public setLInhaconteudo() {
    if (this.linha.comentarios && this.linha.comentarios.length > 0) {
      if (this.posicaoAtual === "Acima") {
        this.comentariosLinhaAtual = this.linha.comentarios.filter(
          (x) => x.range.idItens[0].idItem === this.linha.id
        );
      } else {
        this.comentariosLinhaAtual = this.linha.comentarios.filter(
          (x) =>
            x.range.idItens[x.range.idItens.length - 1].idItem === this.linha.id
        );
      }
    } else {
      this.comentariosLinhaAtual = new Array<Comentario>();
    }

    if (
      this.linha.comentariosGerenciados &&
      this.linha.comentariosGerenciados.length > 0
    ) {
      if (this.posicaoAtual === "Acima") {
        this.comentariosGerenciadosLinhaAtual =
          this.linha.comentariosGerenciados.filter(
            (x) => x.range.idItens[0].idItem === this.linha.id
          );
      } else {
        this.comentariosGerenciadosLinhaAtual =
          this.linha.comentariosGerenciados.filter(
            (x) =>
              x.range.idItens[x.range.idItens.length - 1].idItem ===
              this.linha.id
          );
      }
    } else {
      this.comentariosGerenciadosLinhaAtual = new Array<Comentario>();
    }

    this.comentarios = this.comentariosLinhaAtual.filter(
      (x) => x.mnemonico === false
    );

    this.mnemonicos = this.comentariosLinhaAtual.filter(
      (x) => x.mnemonico === true
    );

    this.comentariosGerenciados = this.comentariosGerenciadosLinhaAtual.filter(
      (x) => x.mnemonico === false
    );

    this.mnemonicosGerenciados = this.comentariosGerenciadosLinhaAtual.filter(
      (x) => x.mnemonico === true
    );

    if (this.linha.marcacoesProva && this.linha.marcacoesProva.length > 0) {
      if (this.posicaoAtual === "Acima") {
        this.marcacoesLinhaAtual = this.linha.marcacoesProva.filter(
          (x) => x.range.idItens[0].idItem === this.linha.id
        );
      } else {
        this.marcacoesLinhaAtual = this.linha.marcacoesProva.filter(
          (x) =>
            x.range.idItens[x.range.idItens.length - 1].idItem === this.linha.id
        );
      }
    } else {
      this.marcacoesLinhaAtual = new Array<Marcacao>();
    }

    this.anyMarcacoes =
      this.comentarios.length > 0 ||
      this.mnemonicos.length > 0 ||
      this.marcacoesLinhaAtual.length > 0;

    if (this.linha.referencias && this.linha.referencias.length > 0) {
      if (this.posicaoAtual === "Abaixo") {
        this.referenciaLinhaAtual = this.linha.referencias.filter(
          (x) =>
            x.links?.find((e) => e.idItem === this.linha.id)?.idItem ===
            this.linha.id
        );
      }
    } else {
      this.referenciaLinhaAtual = new Array<Referencia>();
    }

    if (
      this.linha.referenciasGerenciado &&
      this.linha.referenciasGerenciado.length > 0
    ) {
      if (this.posicaoAtual === "Abaixo") {
        this.referenciagerenciadasReadOnly = true;
        this.referenciagerenciadasLinhaAtual =
          this.linha.referenciasGerenciado.filter(
            (x) => x.idItem === this.linha.id
          );
      }
    } else {
      this.referenciagerenciadasReadOnly = false;
      this.referenciagerenciadasLinhaAtual = new Array<ReferenciaGerenciada>();
    }
  }

  ngOnInit() {
    switch (this.posicaoAtual) {
      case "Acima":
        this.marginBottom = -7;
        this.marginTop = 3;
        break;
      case "Abaixo":
        this.marginBottom = 2;
        this.marginTop = -5;
        break;
    }

    this.isAdm = this.featureFlagService.isAdm(
      this.usuarioPreferenciasService.getConfiguracoesvalue?.email
    );

    this.configuracoes$ = this.usuarioPreferenciasService.getConfiguracoes();

    this.subscriptions.push(
      this.usuarioComentariosService
        .getModificadoComentario()
        .subscribe((c) => this.comentarioChanged(c))
    );
    this.subscriptions.push(
      this.usuarioReferenciaService
        .getModificadoReferencia()
        .subscribe((r) => this.referenciaChanged(r))
    );
    this.subscriptions.push(
      this.usuarioMarcacoesService
        .getModificadoMarcacao()
        .subscribe((m) => this.marcacaoChanged(m))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  // #region Comentarios

  salvarComentario(comentario) {
    this.atualizarComentario(comentario);
  }

  public realcarComentario(idComentario: string): void {
    const col = new Array<TagConteudo>();

    const coment = this.linha.comentarios.find((x) => x.id === idComentario);
    const tag = new TagConteudo(null, coment);
    col.push(tag);

    this.hoverService.destacar(col);
    this.changeDetector.markForCheck();
  }

  public confirmarDelecaoComentario(comentario: Comentario) {
    const tipoComentario = comentario.mnemonico ? "mnemonico" : "comentário";
    const dialogRef = this.dialog.open(SimNaoDialogComponent, {
      width: "250px",
      data: "Deseja mesmo excluir o " + tipoComentario + "?",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.usuarioComentariosService
          .remover(comentario)
          .then(() => {})
          .catch((error) => this.errorHandlerService.handleError(error));
      }
    });
  }

  public async atualizarComentario(c: Comentario, size: any = null) {
    this.hoverService.destacar(null);

    if (c.texto.length > 0) {
      await this.usuarioComentariosService.atualizar(c, true);
    } else {
      await this.usuarioComentariosService.remover(c);
    }

    this.changeDetector.markForCheck();
  }

  public getWidthOfText(texto: string) {
    this._bufferInputWidht = document.createElement("span");
    this._bufferInputWidht.style.border = "none";
    this._bufferInputWidht.style.height = "0";
    this._bufferInputWidht.style.overflow = "hidden";
    this._bufferInputWidht.style.padding = "0";
    this._bufferInputWidht.style.position = "absolute";
    this._bufferInputWidht.style.left = "0";
    this._bufferInputWidht.style.top = "0";
    this._bufferInputWidht.style.zIndex = "-1";
    this._bufferInputWidht.style.fontSize = "10pt";
    document.body.appendChild(this._bufferInputWidht);

    this._bufferInputWidht.textContent = texto;

    const width = this._bufferInputWidht.offsetWidth + 40;
    return width;
  }

  // #endregion

  public confirmarDelecaoProva(prova: Marcacao) {
    const dialogRef = this.dialog.open(SimNaoDialogComponent, {
      width: "250px",
      data: "Deseja mesmo excluir a marcação de prova?",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.usuarioMarcacaoService
          .remover(prova)
          .then(() => {})
          .catch((error) => this.errorHandlerService.handleError(error));
      }
    });
  }

  public realcarProva(idComentario: string): void {
    const col = new Array<TagConteudo>();

    const prova = this.linha.marcacoesProva.find((x) => x.id === idComentario);
    const tag = new TagConteudo(prova, null);
    col.push(tag);

    this.hoverService.destacar(col);
  }

  public filtroMarcacaoProva(value: string) {
    if (value && value.length > 0) {
      value = value.toLowerCase();
      this.provasExistentes = new Array<MarcacoesGroup>();
      this.provasExistentes.push({
        tipo: this._provasExistentes[1].tipo,
        marcacoes: this._provasExistentes[1].marcacoes.filter(
          (x) =>
            FuncoesProva.getLabelProva(x)
              .toLowerCase()
              .indexOf(this.provaTextoBuscando.toLowerCase()) !== -1
        ),
      });
    } else {
      this.provasExistentes = this._provasExistentes;
    }
  }

  // public selecionarProvaExistente(dados: ProvaDados, targ: HTMLElement) {
  //   this.provaEditando.dados = dados;
  //   this.focusLeaveProva(targ);
  // }

  // #endregion

  // #region Comum

  public blurRealce(): void {
    this.hoverService.destacar(null);
  }
  public async deletaReferencia(referencia: Referencia) {
    await this.usuarioReferenciaService.remover(referencia, this.linha.id);
    this.linha.referencias.splice(
      this.linha.referencias.indexOf(referencia),
      1
    );
    this.changeDetector.markForCheck();
  }

  public salvarReferencia(referencia: Referencia) {
    this.onSalvarReferencia.emit(referencia);

    this.criarReferencia = null;

    this.changeDetector.markForCheck();
  }

  public fechaReferencia() {
    this.criarReferencia = null;
  }

  // #endregion

  private comentarioChanged(comentario: Comentario) {
    if (
      !comentario ||
      comentario.range.idItens.map((i) => i.idItem).indexOf(this.linha.id) ===
        -1
    ) {
      return;
    }

    if (
      this.linha.comentarios.indexOf(comentario) !== -1 &&
      comentario.removido
    ) {
      this.linha.comentarios.splice(
        this.linha.comentarios.indexOf(comentario),
        1
      );
    } else if (
      this.linha.comentarios.findIndex((m) => m.id === comentario.id) === -1
    ) {
      if (!comentario.removido) {
        this.linha.comentarios.push(comentario);
      }
    }

    this.setLInhaconteudo();
    this.changeDetector.markForCheck();
  }

  private referenciaChanged(referencia: Referencia) {
    if (
      !referencia ||
      referencia.links.findIndex((i) => i.idItem === this.linha.id) === -1
    ) {
      return;
    }
    if (
      this.linha.referencias.indexOf(referencia) !== -1 &&
      referencia.removido
    ) {
      this.linha.referencias.splice(
        this.linha.referencias.indexOf(referencia),
        1
      );
    } else if (
      this.linha.referencias.findIndex((m) => m.id === referencia.id) === -1
    ) {
      this.linha.referencias.push(referencia);
    } else {
      this.linha.referencias.forEach((m) => {
        if (m.id === referencia.id) {
          m.conteudo = referencia.conteudo;
          m.links = referencia.links;
          m.link = referencia.link;
          m.ref = referencia.ref;
          m.tipo = referencia.tipo;
        }
      });
    }

    this.setLInhaconteudo();
    this.changeDetector.markForCheck();
  }

  private marcacaoChanged(marcacao: Marcacao) {
    if (
      !marcacao ||
      marcacao.range.idItens.map((i) => i.idItem).indexOf(this.linha.id) === -1
    ) {
      return;
    }

    if (
      this.linha.marcacoesProva.indexOf(marcacao) !== -1 &&
      marcacao.removido
    ) {
      this.linha.marcacoesProva.splice(
        this.linha.marcacoesProva.indexOf(marcacao),
        1
      );
    } else if (
      this.linha.marcacoesProva.findIndex((ma) => ma.id === marcacao.id) === -1
    ) {
      this.linha.marcacoesProva.push(marcacao);
    }

    this.setLInhaconteudo();
    this.changeDetector.markForCheck();
  }
}
